__turbopack_context__.v({
  "__left": "SliderHand-module-scss-module__EZPzKW____left",
  "__right": "SliderHand-module-scss-module__EZPzKW____right",
  "sliderHand": "SliderHand-module-scss-module__EZPzKW__sliderHand",
  "sliderHandWrapper": "SliderHand-module-scss-module__EZPzKW__sliderHandWrapper",
  "sliderHandWrapper_visible": "SliderHand-module-scss-module__EZPzKW__sliderHandWrapper_visible",
  "sliderHand__hand": "SliderHand-module-scss-module__EZPzKW__sliderHand__hand",
});
